import { Component, OnInit } from '@angular/core';
import { SaleProductService } from '../../services/sale-product.service';
import { SaleService } from '../../services/sale.service';
import { LabeledProductService } from '../../../labeledproducts/services/labeledproduct.service';
import { InvoiceService } from '../../../common/services/invoice.service';

import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
declare let alasql;

@Component({
  selector: 'app-list-sale',
  templateUrl: './list-sale.component.html',
  styleUrls: ['./list-sale.component.css'],
  providers:[SaleProductService, SaleService,LabeledProductService,InvoiceService]
})
export class ListSaleComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  sales: any = [];
  filters:any = {
    number:{contains: ""},
    number_with_serie:{contains: ""},
  };
  productFilter:any = {
    short_description:{contains: ""},
    name:{contains: ""},
    imei1: {contains: ""},
    serial_number: {contains: ""},
    description: {contains: ""}
  };
  invoiceFilter:any ={
    customer_name:{contains: ""},
    customer_nif:{contains: ""},
    number:{contains: ""},
  };
  fromDate:any;
  untilDate:any;
  exportParams:any ={};
  ids:any;
  invoiceIds:any;
  role:number = 3;

  constructor(private saleProductService: SaleProductService, private saleService:SaleService, private labeledProductService:LabeledProductService, private invoiceService:InvoiceService) { }

  ngOnInit() {
    this.getSales();
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    }
  }

  getFilters(){
    if ((this.productFilter.short_description.contains != '' && this.productFilter.short_description.contains != undefined) || (this.productFilter.name.contains != '' && this.productFilter.name.contains != undefined) 
    ||  (this.productFilter.description.contains != '' && this.productFilter.description.contains != undefined) ||
        (this.productFilter.imei1.contains != '' && this.productFilter.imei1.contains != undefined) || (this.productFilter.serial_number.contains != '' && this.productFilter.serial_number.contains != undefined)){
          this.invoiceIds = null;
          this.getSaleProducts();
    }else if ((this.invoiceFilter.customer_name.contains != '' && this.invoiceFilter.customer_name.contains != undefined) || 
              (this.invoiceFilter.customer_nif.contains != '' && this.invoiceFilter.customer_nif.contains != undefined) || 
              (this.invoiceFilter.number.contains != '' && this.invoiceFilter.number.contains != undefined)){
      this.ids = null;
      this.getInvoice();
    }else{
      this.invoiceIds = null;
      this.ids = null;
      this.getSales();
    }
  }

  getInvoice(){
    let params = {
      where: _.cloneDeep(this.invoiceFilter)
    };
    this.invoiceService.query(params)
    .subscribe((invoices) => {
      this.invoiceIds = _.compact(invoices.map(e => e.id))
      this.getSales();
    });
  }

  getSaleProducts(){
    let params = {
      where: _.cloneDeep(this.productFilter),
      limit:1000
    };
    this.labeledProductService.query(params)
      .subscribe((products) => {
        let params = {
          where:{
            labeledproduct_id:_.compact(products.map(e => e.id))
          }
        };
        this.saleProductService.query(params)
        .subscribe((saleProducts) => {
          this.ids = _.compact(saleProducts.map(e => e.sale_id))
          this.getSales();
        });
      });
  }
  
  getSales(){
    var params = {
      where: _.cloneDeep(this.filters),
      sort: 'id DESC',
      skip: (this.p-1)*10,
      limit: 10
    };
    if (this.ids && !params.where.id){
      params.where.id = this.ids;
    }
    if (this.invoiceIds && !params.where.invoice_id){
      params.where.invoice_id = this.invoiceIds;
    }
    if (this.fromDate && moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date[">="] = moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    if (this.untilDate && moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date["<="] = moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD 23:59:59");
    }
    this.exportParams = params;
    this.saleService.query(params)
      .subscribe((sales) => {
          this.sales = sales;
          let countParams = {
            where: _.cloneDeep(params.where),
          };
          this.saleService.count(countParams)
          .subscribe((count) => {
            this.totalItems = count.count;
          });
          this.getProductsFromSale();
      });
  }

  getProductsFromSale(){
    let params = {
      where:{
        sale_id:_.compact(this.sales.map(e => e.id))
      }
    };
    this.saleProductService.query(params)
    .subscribe((saleProducts) => {
      let groupedSaleProducts = _.groupBy(saleProducts, (element)=> {return element.sale_id})
       this.sales.forEach( (s) =>{
        s.description ="";
         if (groupedSaleProducts[s.id] && groupedSaleProducts[s.id].length > 0){
          groupedSaleProducts[s.id].forEach((e, index) =>{
            if (index < 3){
              s.description += e.labeledproduct.name + ", ";
            }
          });
          s.description = s.description .slice(0, -2) ;
          if (groupedSaleProducts[s.id].length >= 3){
            s.description += "..."
          }
         }
       });
    });
  }

  exportSalesToExcel(){
    var options = {   
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: false,
        showTitle: false,
        useBom: false,   
        bookType:'xlsx' ,  
        cellStyles:true,
    };             
    let report = [
          {
              field1:"Número",
              field2:"Fecha",
              field3:"Productos",
              field4:"Total",
              field5:"Método de pago",
              field6:"Usuario"
              
          }
      ]
      delete this.exportParams.skip;
      delete this.exportParams.limit;
      this.saleService.query(this.exportParams)
               .subscribe((sales) => {
      let paramsProducts = {
        where: {
          sale_id: sales.map(e => e.id)
        }
      }
      this.saleProductService.query(paramsProducts)
      .subscribe((saleProducts) => {
        let groupedSaleProducts = _.groupBy(saleProducts, (element)=> {return element.sale_id})
        sales.forEach( (s) =>{
          if (groupedSaleProducts[s.id] && groupedSaleProducts[s.id].length > 0){
           s.description = ""; 
           groupedSaleProducts[s.id].forEach((e, index) =>{
             if (index < 3){
               if (e.labeledproduct){
                s.description += e.labeledproduct.name + ", ";
               }
             }
           });
           s.description = s.description .slice(0, -2) ;
           if (groupedSaleProducts[s.id].length >= 3){
             s.description += "..."
           }
          }
        });
            sales.forEach(sale =>{
                  var row = {
                      field1:sale.id,
                      field2:sale.date?moment(sale.date).format("DD-MM-YYYY"):"",
                      field3:sale.description,
                      field4:sale.total,
                      field5:sale.method_of_payment,
                      field6:sale.createdBy.username
                      
                  }
                  report.push(row);
                
              });
              
              var mystyle = {   
                  headers:true,       
                  columns:    
                      [{columnid:'field1',width:50,title: ''},   
                      {columnid:'field2',width:100,title: ''},
                      {columnid:'field3',width:500,title: 'LISTADO DE VENTAS'},
                      {columnid:'field4',width:100,title: ''},
                      {columnid:'field5',width:100,title: ''},
                      {columnid:'field6',width:100,title: ''}
                      
                      ],
                  /*header*/
                
                  column: {  
                      style:{
                          Alignment:{
                              Horizontal:"Center",
                              Vertical:"Center",  
                              WrapText:1
                              
                          },
                          Font:{
                              Bold:"1",
                              Color:"#000000",
                              Size:10
                          },
                          
                          Interior:{
                              Color:"#7CEECE",
                              Pattern:"Solid"
                          }
                      }},
                cells: {    
                      0:{
                          0:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid",
                                      },
                              Alignment:{
                                Horizontal:"Center",
                                Vertical:"Center",
                                WrapText: 1,
                                  },  
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                              },                        
                              }  
                          },
                          1:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                          },  
                              Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },            
                                  }
                          },
                          2:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      }, 
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          }                
                                  }
                              },
                          3:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1,
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },            
                                    
                                  }
                              },
                          4:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                           
                                  }
                              },
                          5:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                              },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                           
                                  }
                              },   
                      }   
                },
          };
          alasql.promise('SELECT * INTO XLSXML("Ventas_'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
          .then(function(data){
              console.log('Data saved');
          }).catch(function(err){
              console.log('Error:', err);
          });
        });
      });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/sales/components/list-sale/list-sale.component.ts